<template>
  <div class="lib-input-and-extra-container">
    <input
        :type="showPassword ? 'text' : 'password'"
        :name="name"
        :placeholder="placeholder"
        :id="name"
        required
        autocomplete="new-password"
        data-msg-required="Please enter a password."
        data-msg-equal-to="Passwords do not match."
    />
    <div class="lib-input-extra">
      <button @click="showPassword = !showPassword" type="button" class="visibility-button" tabindex="-1">
        <i class="fa-regular" :class="{'fa-eye': !showPassword, 'fa-eye-slash': showPassword}"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
    name: 'PasswordInputWithToggle',
    props: ['name', 'placeholder'],
    data: function() {
        return {
            showPassword: false,
        }
    }
};
</script>

<style lang="scss">
.lib-input-and-extra-container label.error {
    position: absolute;
    top: 40px;
}
</style>

<style scoped lang="scss">
@import "../../../src/scss/prelude";

.lib-input-and-extra-container {
  position: relative;
  display: flex;
  align-items: end;
  width: 100%;
  max-width: 490px;

  .input-wrapper {
    width: 100%;
  }
}

.lib-input-extra {
    height: 40px;
    position: relative;
    padding: 0;
    cursor: pointer;

    color: $gray;

    &:hover {
        color: $darkgray;
    }

    > * {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 12px;
        width: 20px;
        padding: 0;
        text-align: center;
    }
}
</style>